// src/pages/Home.js
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = styled.section`
  background: linear-gradient(180deg, 
    ${props => props.theme.colors.primary}, 
    ${props => props.theme.colors.secondary}
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing.xxl} 0;
  color: white;
  text-align: center;
  min-height: 90vh;
  width: 100%;
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.xl};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const MainTitle = styled(motion.h1)`
  font-size: 64px;
  margin-bottom: ${props => props.theme.spacing.lg};
  background: linear-gradient(45deg, 
    ${props => props.theme.colors.primaryLight}, 
    white
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 40px;
  }
`;

const SubTitle = styled(motion.p)`
  font-size: 24px;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  opacity: 0.9;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ServicesSection = styled.div`
  background: ${props => props.theme.colors.background};
  padding: ${props => props.theme.spacing.xxl} 0;
`;

function Home() {
  return (
    <>
      <HeroSection>
        <HeroContent>
          <MainTitle
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Technical Consulting & Development
          </MainTitle>
          <SubTitle
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Building inclusive, modern, and efficient web solutions
          </SubTitle>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <Link to="/projects">
              <Button>Projects</Button>
            </Link>
          </motion.div>
        </HeroContent>
      </HeroSection>
      {/* Rest of your home page content */}
    </>
  );
}

const Button = styled.button`
  background: ${props => props.theme.colors.accent};
  color: white;
  border: none;
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.xl};
  border-radius: 30px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  margin-top: ${props => props.theme.spacing.xl};
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export default Home;